exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-dda8aac6] .el-card__body{height:100%}.card__body--nopadding[data-v-dda8aac6] .el-card__body{padding:10px}.el-dialog .el-card[data-v-dda8aac6],[data-v-dda8aac6] .el-card .el-card{border:1px solid var(--lineBorderColor)!important}.to-model-preview[data-v-dda8aac6]{cursor:pointer}.model_message_wrap[data-v-dda8aac6]{background-color:#f5f5f5!important;color:#000!important}.model_message_wrap[data-v-dda8aac6] .el-checkbox__inner{border-color:#000!important}.modelTree-tree[data-v-dda8aac6]{height:calc(100% - 84px)}", ""]);

// exports
